import type { ForwardedRef } from 'react';

/** Assign a node to a forwarded ref, whichever shape (callback or object) it is. */
export function setRef<T>(ref: ForwardedRef<T> | undefined, node: T | null): void {
  if (typeof ref === 'function') ref(node);
  else if (ref) ref.current = node;
}
